import { Expose, Transform } from "class-transformer";
import { round, toCents } from "@/utils/numberUtils";

export class CreatePurchaseOrderLineDto {
  @Expose()
  quantity: number;

  @Expose()
  @Transform(({ value }) => toCents(round(value, 2)))
  unitPrice: number;

  @Expose()
  itemModelId?: string;

  @Expose()
  consumableId?: string;

  @Expose()
  serviceId?: string;

  @Expose()
  externalReference?: string;

  @Expose()
  notes?: string;

  @Expose()
  isRepair?: boolean;
}
